import React from 'react';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { media } from 'legacyComponents/styled/styleUtils';
import { MainWrapper, Div } from 'legacyComponents/styled/lib';
import {
  SideNavBarWrapper,
  SideNavBar,
  SideNavBarItem,
  SideNavBarLink,
} from 'legacyComponents/sideNavBar';

import { routeNode, routerStore } from 'core/routing';

import { FourOhFour } from 'apps/fourOhFour';

// import { Home } from "apps/project/settings/tabs/home";
import { GeneralSettings } from 'apps/project/settings/tabs/general';
import { TeamSettings } from 'apps/project/settings/tabs/team';
import { AdminSettings } from 'apps/project/settings/tabs/admin';
import { ProjectSettingsAppManager } from 'apps/project/settings/appManager';
import { GroupsAppManager } from 'apps/group/appManager';

const viewsMap = {
  teams: TeamSettings,
  general: GeneralSettings,
  admin: AdminSettings,
};

@inject('clientStore')
@observer
export class ProjectSettings extends React.Component {
  UNSAFE_componentWillMount() {
    this.manager = new ProjectSettingsAppManager(null, this.props);
    this.groupsManager = new GroupsAppManager(null, this.props);
  }

  render() {
    const View = this.props.componentFromRoute();
    const { clientStore } = this.props;
    const { loading, notFound, canUpdate } = this.manager;

    if (!loading && (notFound || (!canUpdate && !clientStore.isStaff))) {
      return <FourOhFour />;
    }

    const {
      route: { name },
      projectManager,
      routerStore: { params },
    } = this.props;

    const profileName = params.get('profile');
    const initiativeName = params.get('initiative');
    const spaceType = profileName ? 'profile' : 'initiative';
    const spaceParams = {
      [spaceType]: profileName || initiativeName,
      slug: params.get('slug'),
    };
    if (projectManager && !this.groupsManager.loading) {
      return (
        <MainWrapper>
          <Div display='inline-block' width='100%'>
            <SideNavBarWrapper>
              <SideNavBar>
                <SideNavBarItem isTitle>
                  <Trans>Project Settings</Trans>
                </SideNavBarItem>
                {canUpdate && (
                  <SideNavBarItem>
                    <SideNavBarLink
                      name={`${spaceType}.project.settings.teams`}
                      params={spaceParams}
                      active={name.includes('teams')}
                    >
                      <Trans>Member privileges</Trans>
                    </SideNavBarLink>
                  </SideNavBarItem>
                )}
                {canUpdate && (
                  <SideNavBarItem last>
                    <SideNavBarLink
                      name={`${spaceType}.project.settings.general`}
                      params={spaceParams}
                      active={name.includes('general')}
                    >
                      <Trans>General</Trans>
                    </SideNavBarLink>
                  </SideNavBarItem>
                )}
                {clientStore.isStaff && (
                  <SideNavBarItem>
                    <SideNavBarLink
                      name={`${spaceType}.project.settings.admin`}
                      params={spaceParams}
                      active={name.includes('admin')}
                    >
                      <Trans>Admin tasks</Trans>
                    </SideNavBarLink>
                  </SideNavBarItem>
                )}
              </SideNavBar>
            </SideNavBarWrapper>
            <SettingsWrapper>
              <View
                params={params}
                projectSettingsAppManager={this.manager}
                projectManager={projectManager}
                groupsManager={this.groupsManager}
              />
            </SettingsWrapper>
          </Div>
        </MainWrapper>
      );
    }
    return null;
  }
}

// TODO: Move SettingsWrapper to a shared file
export const SettingsWrapper = styled.div`
  width: calc(75% - 10px);
  float: right;
  margin-top: ${props => props.theme.spacing.large};
  margin-bottom: 60px;
  padding: 0 30px;
  height: auto;
  ${media.l`
    width: calc(73% - 10px);
  `};
  ${media.m`
    width: 100%;
    padding: 0 20px;
  `};
`;

ProjectSettings.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
  projectManager: PropTypes.object,
  clientStore: PropTypes.object,
};

@inject('clientStore')
class RedirectToTeam extends React.Component {
  constructor(props) {
    super(props);
    const {
      route: { name, params },
    } = routerStore;
    const { clientStore } = props;
    const tab = clientStore.isStaff ? 'admin' : 'teams';
    routerStore.navigate(`${name}.${tab}`, params, { replace: true });
  }

  render() {
    return null;
  }
}

RedirectToTeam.propTypes = {
  clientStore: PropTypes.object,
};

export const ProfileProjectSettingsRouter = routeNode(
  'profile.project.settings',
  viewsMap,
  RedirectToTeam,
)(ProjectSettings);

export const InitiativeProjectSettingsRouter = routeNode(
  'initiative.project.settings',
  viewsMap,
  RedirectToTeam,
)(ProjectSettings);
